import { StyleSheet, Text, View } from "@react-pdf/renderer";
import { MinMaxAvg } from "../../../../../actions/Tenants/config/constantsTyped";

const styles = StyleSheet.create({
    container: {
        paddingTop: 6,
        borderRadius: 5,
        marginLeft: 5,
        marginRight: 5,
    },
    table: {
        borderWidth: 1,
        borderColor: "#939496",
        borderRadius: 5,
        width: "100%",
    },
    tableRow: {
        flexDirection: "row",
    },
    tableCell: {
        flex: 1,
        padding: 4,
        borderRightWidth: 1,
        borderColor: "#939496",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        fontSize: 14,
        color: "black",
        fontFamily: "Poppins-Medium",
    },
    lastCell: {
        borderRightWidth: 0,
    },
});

interface PDFDryMatterMinMaxAvgOverviewProps {
    dryMatterMinMaxAvg?: MinMaxAvg;
    xMarging?: number;
}


const PDFDryMatterMinMaxAvgOverview: React.FC<PDFDryMatterMinMaxAvgOverviewProps> = ({ dryMatterMinMaxAvg, xMarging = 5 }: PDFDryMatterMinMaxAvgOverviewProps) => {
    return (
        <View style={[styles.container, { marginLeft: xMarging, marginRight: xMarging }]}>
            <View style={styles.table}>
                <View style={styles.tableRow}>
                    <View style={styles.tableCell}>
                        <Text>Dry matter:</Text>
                    </View>
                    <View style={styles.tableCell}>
                        <Text>Min: {dryMatterMinMaxAvg?.min || "-"}</Text>
                    </View>
                    <View style={styles.tableCell}>
                        <Text>Max: {dryMatterMinMaxAvg?.max || "-"}</Text>
                    </View>
                    <View style={[styles.tableCell, styles.lastCell]}>
                        <Text>Avg: {dryMatterMinMaxAvg?.avg || "-"}</Text>
                    </View>
                </View>
            </View>
        </View>
    );
};

export default PDFDryMatterMinMaxAvgOverview;
